import { request } from '@umijs/max';
import { ConsumerAuthAccount, LoginParams, LoginResultData } from '../ConsumerTypings';

export namespace ConsumerPassport {
  /**
   * @summary 登录
   * @secure
   */
  export const login = async (data: LoginParams, params: { [key: string]: any } = {}) => {
    return request<LoginResultData>(`/consumer/passport/login`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 注销登录
   * @secure
   */
  export const logout = async (params: { [key: string]: any } = {}) => {
    return request<boolean>(`/consumer/passport/logout`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 获取登录信息
   * @secure
   */
  export const auth = async (params: { [key: string]: any } = {}) => {
    return request<ConsumerAuthAccount>(`/consumer/passport/auth`, {
      method: 'GET',
      ...params,
    });
  };
}

export default ConsumerPassport;

export const login = ConsumerPassport.login;
export const logout = ConsumerPassport.logout;
export const auth = ConsumerPassport.auth;
